import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Form, Icon, Search, Button,
} from 'semantic-ui-react';
import useTermsAutocomplete from '../hooks/useTermsAutocomplete';

const SearchExpertForm = () => {
  const history = useHistory();
  const [query, setQuery] = useState('');
  const {
    results,
    isLoading,
    handleSearchChange,
    resultRenderer,
  } = useTermsAutocomplete();

  const handleResultSelect = (e, { result }) => {
    const selectedTerm = result.title.replace(/<[^>]*>/g, '');
    setQuery(selectedTerm);
    // Submit the form with the selected term
    if (selectedTerm.trim()) {
      history.push({ pathname: '/search', search: `?queries=${[selectedTerm]}` });
    }
  };

  const handleSubmit = () => {
    const newQuery = query.trim();
    if (newQuery) history.push({ pathname: '/search', search: `?queries=${[newQuery]}` });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Search
        resultRenderer={resultRenderer}
        fluid
        input={{ fluid: true }}
        placeholder="Search, e.g. 'liquid biopsy', 'single cell', 'crispr'"
        className="nav-item"
        value={query}
        onSearchChange={(e, data) => handleSearchChange(e, data, setQuery)}
        onResultSelect={handleResultSelect}
        results={results}
        loading={isLoading}
        icon={<Button icon><Icon name="search" /></Button>}
      />
    </Form>

  );
};

export default SearchExpertForm;
